export default __webpack_public_path__ + "f797c314ff4e0b75b831cf0f09f03718.png";